import { render, staticRenderFns } from "./BuyerChannelBidding.vue?vue&type=template&id=644e7e66&scoped=true"
import script from "./BuyerChannelBidding.vue?vue&type=script&lang=js"
export * from "./BuyerChannelBidding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e7e66",
  null
  
)

export default component.exports